import React from 'react';
import i18n from 'app/common/lib/i18n';
import PropTypes from 'prop-types';

const styles = {
  fullPageInspiredInterests: {
    color: '#fff',
    fontSize: '11px',
    fontWeight: 'normal',
    maxWidth: '135px',
    padding: '4px 7px',
  },
  containerInspiredInterests: {
    color: '#aaa',
    fontSize: '11px',
    fontWeight: 'bold',
    maxWidth: '135px',
    padding: '4px 9px',
    whiteSpace: 'nowrap',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
  },
  containerWrapper: {
    display: 'flex',
    textAlign: 'center',
    flexFlow: 'row wrap',
    alignItems: 'center',
    margin: 'auto 26px 8px 26px',
    justifyContent: 'center',
    lineHeight: '7px',
  },
  fullPageWrapper: {
    margin: '0px 0px 16px 0px',
    textAlign: 'center',
    width: '100%',
  },
  topWrapper: {
    top: '10px',
    left: '0px',
    marginTop: '6px',
    position: 'absolute',
    textAlign: 'center',
    width: '100%',
  },
};

const countryUrlMapper = (language) => {
  let url = 'https://itunes.apple.com/us/app/pinterest/id429047995';
  switch (language) {
    case 'en':
      break;
    case 'es':
      url = 'https://itunes.apple.com/es/app/pinterest/id429047995';
      break;
    case 'ja':
      url = 'https://itunes.apple.com/jp/app/pinterest/id429047995';
      break;
    case 'fr':
      url = 'https://itunes.apple.com/fr/app/pinterest/id429047995';
      break;
    case 'pt':
      url = 'https://itunes.apple.com/pt/app/pinterest/id429047995';
      break;
    case 'hi':
      url = 'https://itunes.apple.com/in/app/pinterest/id429047995';
      break;
    case 'de':
      url = 'https://itunes.apple.com/de/app/pinterest/id429047995';
      break;
    case 'it':
      url = 'https://itunes.apple.com/it/app/pinterest/id429047995';
      break;
    default:
    // default url value already set
  }
  return url;
};

export function InspiredInterests(props, context) {
  const { color, useContainerStyles } = props;
  let linkStyles = styles.fullPageInspiredInterests;
  let wrapperStyles = styles.fullPageWrapper;

  if (useContainerStyles) {
    linkStyles = styles.containerInspiredInterests;
    wrapperStyles = styles.containerWrapper;
  }

  if (color) {
    linkStyles = { ...linkStyles, color };
  }

  return (
    <div style={wrapperStyles}>
      <a href={'/_/_/about/'} style={linkStyles}>
        {i18n._('About Pinterest')}
      </a>
      <a href={'/_/_/blog/'} style={linkStyles}>
        {i18n._('Blog')}
      </a>
      <a href={'/_/_/business/'} style={linkStyles}>
        {i18n._('Businesses')}
      </a>
      <a href={'/_/_/about/terms-service/'} style={linkStyles}>
        {i18n._('Terms of Service')}
      </a>
      <a href={'/_/_/about/privacy/'} style={linkStyles}>
        {i18n._('Privacy Policy')}
      </a>
      {context.country === 'DE' ? (
        <a href={'/_/_/about/impressum'} style={linkStyles}>
          {i18n._('Imprint')}
        </a>
      ) : null}
      <a href={'/_/_/help/?utm_campaign=signup_page&utm_source=web'} style={linkStyles}>
        {i18n._('Help')}
      </a>
      <a href={countryUrlMapper(context.language)} style={linkStyles}>
        {i18n._('iPhone App')}
      </a>
      <a href={'https://play.google.com/store/apps/details?id=com.pinterest'} style={linkStyles}>
        {i18n._('Android App')}
      </a>
      <a href={'/html_sitemap/pinners_a.html'} style={linkStyles}>
        {i18n._('Users')}
      </a>
      <a href={'/html_sitemap/boards_a.html'} style={linkStyles}>
        {i18n._('Collections')}
      </a>
    </div>
  );
}

InspiredInterests.propTypes = {
  useContainerStyles: PropTypes.bool,
  color: PropTypes.string,
};

InspiredInterests.contextTypes = {
  origin: PropTypes.string.isRequired,
  isBot: PropTypes.bool.isRequired,
  country: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
};

export default InspiredInterests;
